// utils/country-flag.ts
//
// Converts ISO-3166-1 alpha-2 country code (e.g. "CH") to the
// corresponding Unicode flag emoji (🇨🇭) via regional-indicator symbols.
// Returns empty string for invalid input — UI should handle absent flag.

export function countryFlag(countryCode: string | undefined | null): string {
  if (!countryCode || typeof countryCode !== 'string') return ''
  const cc = countryCode.trim().toUpperCase()
  if (cc.length !== 2) return ''
  if (!/^[A-Z]{2}$/.test(cc)) return ''
  const base = 127397 // 0x1F1A5 — offset from 'A' to 🇦
  return String.fromCodePoint(base + cc.charCodeAt(0)) +
         String.fromCodePoint(base + cc.charCodeAt(1))
}
